import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";
export const GetLogs = async ({
  limit = DEFAULT_LIMIT,
  page = 1,
  statusCode = "",
  dateFrom = "",
  dateTo = "",
  email = "",
  request = "",
  action = "",
}) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `log?&limit=${limit}&page=${page}&statusCode=${statusCode}&startedAt=${dateFrom}&endedAt=${dateTo}&email=${email}&searchQuery=${request}&action=${action}`,
    options
  );
};
